// components/calendar/CalendarLegend.js
// Legenda colori eventi calendario

import React from 'react';

const LEGEND_ITEMS = [
  { type: 'sopralluogo', label: 'Sopralluogo', color: 'bg-[#4A90A4]' },
  { type: 'sede', label: 'Sede/Presentazione', color: 'bg-[#5B9BD5]' },
  { type: 'scelta_extra', label: 'Scelta Extra', color: 'bg-[#70AD47]' },
  { type: 'personale', label: 'Personale/Interno', color: 'bg-[#7F7F7F]' },
  { type: 'google', label: 'Google Calendar', color: 'bg-[#DB4437]' },
  { type: 'annullato', label: 'Annullato', color: 'bg-[#D9D9D9]' },
];

const CalendarLegend = ({ compact = true }) => {
  if (compact) {
    return (
      <div className="flex flex-wrap items-center gap-3 text-xs text-[#737373]">
        {LEGEND_ITEMS.map(item => (
          <div key={item.type} className="flex items-center gap-1">
            <div className={`w-3 h-3 rounded-sm ${item.color}`} />
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="p-3 bg-white border border-[#DCDCDC] rounded-lg">
      <h4 className="text-sm font-medium text-[#3C3C3C] mb-2">Legenda</h4>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        {LEGEND_ITEMS.map(item => (
          <div key={item.type} className="flex items-center gap-2">
            <div className={`w-4 h-4 rounded-sm ${item.color}`} />
            <span className="text-sm text-[#737373]">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CalendarLegend;
